<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ülke</label>
            <v-validator :errors="errors" parameter="CountryId" :watch="country">
                <v-select-list v-model="country" v-on:input="getProvinces(true)" placeholder="Ülke" label="Name" :options="countries"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İl</label>
            <v-validator :errors="errors" parameter="ProvinceId" :watch="province">
                <v-select-list :disabled="!country" v-model="province" placeholder="Şehir/İl" v-on:input="getDistricts(true)" label="Name" :options="provinces"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İlçe</label>
            <v-validator :errors="errors" parameter="DistrictId" :watch="district">
                <v-select-list :disabled="!province" placeholder="İlçe" v-model="district" label="Name" :options="districts"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Mahalle</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name" >
                <input type="text" class="form-control" :disabled="!district" placeholder="Mahalle" v-model="value.Name">
            </v-validator>
        </div>
    </div>
</template>

<script>
    import SystemDataApi from '@/api/system-data'

    export default {
        props:{
            value:Object,
            errors:Object
        },
        data() {
            return {
                countries:[],
                provinces: [],
                districts: [],
            }
        },
        mounted(){
            this.getCountries()
            this.getProvinces()
            this.getDistricts()
        },
        methods : {
            getCountries(){
                if((this.countries || []).length == 0){
                    SystemDataApi.Country().then(res=>{
                        this.countries = res.data.Data
                        if(this.value.CountryId == null){
                            this.value.CountryId = this.countries?.find(c=>c.IsDefault)?.Id  || null
                        }
                        this.getProvinces()
                    })
                }else {
                    if(this.value.CountryId == null){
                        this.value.CountryId = this.countries?.find(c=>c.IsDefault)?.Id  || null
                    }
                    this.getProvinces()
                }
            },
            getProvinces(bool){
                if(bool) this.value.ProvinceId = null
                if(this.value.CountryId){
                    SystemDataApi.ProvinceByCountry(this.value.CountryId).then(response=>{
                        this.provinces = response.data.Data
                    })
                }
            },
            getDistricts(){
                if(this.value.ProvinceId){
                    SystemDataApi.District(this.value.ProvinceId)
                    .then(res=>{
                        this.districts = res.data.Data
                    })
                }
            }
        },
        computed : {
            country:{
                get:function(){
                    return this.countries.find(b=>b.Id==this.value.CountryId)
                },
                set:function(value){
                    this.value.CountryId = value?.Id || null
                }
            },
            province:{
                get:function(){
                    return this.provinces.find(b=>b.Id==this.value.ProvinceId)
                },
                set:function(value){
                    this.value.ProvinceId = value?.Id || null
                }
            },
            district:{
                get:function(){
                    return this.districts.find(b=>b.Id==this.value.DistrictId)
                },
                set:function(value){
                    this.value.DistrictId = value?.Id || null
                }
            }
        }
    }
</script>